<template>
    <div id="error">
        <div>
            <transition name="fade" enter-active-class="animated bounceIn" :duration="200">
                <div class="codeIndexDialogMask">
                <div
                    class="adoptDialog failDialog adoptDialog_en"
                    :style = "{ background: `url(${IMG_BASE_URL}popWin_03.png) no-repeat`}"
                >
                    <!-- 失败弹窗标题 范围 -->
                    <div class="failDialogTitle">
                    <!-- 失败弹窗标题 文字 -->
                    <div class="failDialogTitle_txt" :dir="dirLang" >{{$t('retry')}}</div>
                    </div>
                    <!-- 失败弹窗内容 范围 -->
                    <div class="failDialogContent">
                    <!-- 失败弹窗内容 文字 -->
                    <div class="failDialogContent_txt" :dir="dirLang">{{$t('jump_error')}}</div>
                    </div>
                    <div
                    class="adoptLeftBtn failAcceptClick"
                    :style = "{ background: `url(${IMG_BASE_URL}popWin_10.png) no-repeat`}"
                    @click="failAcceptClick"
                    ></div>
                </div>
                </div>
            </transition>
        </div>
    </div>
</template>
<script>
import store from "../store";
import { mapGetters } from "vuex";
import AdventureManager from "../manager/AdventureManager";
export default {
    data() {
        return {

        }
    },
    mounted() {
        let lan =  AdventureManager.getLanguage();
        this.$i18n.locale = lan;
        
        if (lan == 'ar' || lan == 'he') store.state.dirLang = 'rtl';
        else store.state.dirLang = 'ltr';
    },
    updated() {   
        this.$nextTick(() => {this.resize()});
    },
    methods: {
        failAcceptClick(){
            window.location.href = 'about:blank';
            window.close();
        },
        resize() {
            this.screenWidth = document.body.clientWidth;
            this.screenHeight = document.body.clientHeight;
      
            if(this.screenWidth >= 1440 & this.screenHeight >= 900){
                $(".codeIndexDialogMask").css('transform', 'scale(1)');
            } else {
                let scale = Math.min(this.screenWidth/1440, this.screenHeight/900);
                $(".codeIndexDialogMask").css('transform', `scale(${scale})`);
            }
        },
    },
    computed: {
        ...mapGetters(["allImageMap",'dirLang'])
    },  
}
</script>
<style lang="">
#error{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}
.codeIndexDialogMask {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 2000;

    display: flex;
    align-items: center;
    justify-content: center;
}
.adoptDialog_en {
    width: 556px;
    height: 439px;
}
.adoptDialog {
    box-sizing: border-box;
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 2000;
}
.failDialogTitle {
    position: absolute;
    width: 249px;
    height: 72px;
}
.failDialogTitle_txt {
    position: absolute;
    width: 100%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    line-height: 24px;
    color: #fafafa;
    font-size: 24px;
    font-weight: bold;
}
.failDialogContent {
    position: absolute;
    left: 50px;
    right: 50px;
    top: 90px;
    bottom: 150px;
}
.failDialogContent_txt {
    position: absolute;
    width: 100%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    line-height: calc(19px * 1.5);
    color: #fafafa;
    font-weight: bold;
    font-size: 19px;
}
.failAcceptClick{
    width: 182px;
    right: 185px;
    bottom: 25px;
    height: 87px;
}
.adoptLeftBtn {
    position: absolute;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/errorMsg.vue